import React from "react";
import Image from "next/image";
import HeroImage from '../../public/img/hero/sustainability_2025_2.webp';

export default function HeroSustainability(props)
{
    return (
        <section className="relative bg-bb mt-[102px] lg:mt-[127px] overflow-hidden">
            <div className="container px-0 z-hero-fg flex flex-col sm:flex-row">
                <div className="py-40 sm:pb-0 md:pt-80 xl:pt-100 col-span-2 bg-bb px-[1.5rem] sm:px-[2.0rem] sm:max-w-[340px] lg:max-w-[400px] ">
                    <h1 className="text-white text-[2.0rem] sm:text-[1.5rem] lg:text-[2.0rem] leading-[2.4rem] sm:leading-[1.8rem] lg:leading-[2.4rem] pb-20">
                        Our Commitment to a Sustainable Future
                    </h1>
                    <p className="text-white pb-20 sm:pb-40 sm:text-copy-sm lg:text-copy">At Solvar, we take climate action seriously, striving to reduce our footprint wherever it is feasible.</p>
                    <div className="relative hidden sm:block -ml-[30%] mr-[30%]">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 470.27 191.15">
                            <path d="M441.9,191.15c17.65-20.11,28.37-46.44,28.37-75.29,0-63.1-51.15-114.24-114.23-114.24-21.13,0-40.92,5.74-57.89,15.73L36.82,191.15h405.09Z" className="fill-cc" />
                            <path d="M17.8,191.15L285.94,9.14c2.28-1.55,2.88-4.66,1.33-6.94-1.55-2.28-4.66-2.88-6.94-1.33L0,191.15h17.8Z" className="fill-cc" />
                        </svg>
                    </div>
                </div>
                <div className="grow relative">
                    <div className="min-h-[30vh] sm:min-h-[auto] sm:absolute sm:top-0 sm:left-0 sm:bottom-0 sm:-right-[calc(100vw-100%)]">
                        <Image
                            src={ HeroImage }
                            alt="solvar"
                            layout="fill"
                            objectFit="cover"
                            priority={ true }
                        />
                    </div>
                    <div className="hidden sm:block w-[50px] absolute left-0 top-0 bottom-0">
                        <svg className="h-[100%]"xmlns="http://www.w3.org/2000/svg" viewBox="0 0 96.54 360.32">
                            <path d="M9,181C9,107.65,43.21,42.29,96.54,0H0v360.32h94.45C42.32,317.98,9,253.39,9,181Z" className="fill-bb"/>
                        </svg>
                    </div>
                </div>
            </div>
        </section>
    );
}